import Cookies from 'js-cookie'
// import Index from '@/views/account-index'
import NoCustomer from '@scope/views/accounts/no-customer'
import AccountDefaultLayout from '@scope/views/accounts/layouts/Default'
import AccountUserInfo from '@scope/views/accounts/user-info'
import AccountReportProject from '@scope/views/accounts/report-project'
import DownloadHistory from '@scope/views/accounts/download-history'
import EditPassword from '@scope/views/accounts/edit-password'
import AccountLicense from '@scope/views/accounts/license'
import AccountTechSupport from '@scope/views/accounts/tech-support'
import AccountBilling from '@scope/views/accounts/billing'
import Checkout from '@scope/views/checkout'
const OP_PATH = process.env.OP_PATH
const _meta = { layout: 'full-screen', canRenderDefaultLayout: false }

export default {
  path: '/account',
  component: AccountDefaultLayout,
  meta: _meta,
  redirect: { name: 'AccountLicense' },
  children: [
    {
      name: 'AccountUserInfo',
      path: '',
      component: AccountUserInfo,
      meta: _meta,
      beforeEnter: (to, from, next) => {
        if (Cookies.get('yunionauth')) {
          next()
        } else {
          window.location.href = `${OP_PATH}/auth`
        }
      },
    },
    {
      name: 'AccountReportProject',
      path: 'reportProject',
      component: AccountReportProject,
      meta: _meta,
    },
    {
      name: 'DownloadHistory',
      path: 'downloadhistory',
      component: DownloadHistory,
      meta: _meta,
    },
    {
      name: 'EditPassword',
      path: 'editPassword',
      component: EditPassword,
      meta: _meta,
    },
    {
      path: 'license',
      name: 'AccountLicense',
      component: AccountLicense,
      meta: _meta,
    },
    {
      path: 'tech-support',
      name: 'AccountTechSupport',
      component: AccountTechSupport,
      meta: _meta,
    },
    {
      path: 'billing',
      name: 'AccountBilling',
      component: AccountBilling,
      meta: _meta,
    },
    { name: 'NoCustomer', path: 'no-customer', component: NoCustomer, meta: _meta },
    { name: 'Checkout', path: 'checkout', component: Checkout, meta: { layout: 'full-screen' } },
  ],
}
